import React, { useEffect } from "react";
import { LanguageConstants } from "../constants/LanguageConstants";
import { useState } from "react";
import fillStart from "../Assets/images/star.png";
import halfStart from "../Assets/images/star-outline.png";
import useMakeRequest from "../utils/ApiHelper";
import { ApiConstants } from "../constants/ApiConstants";
import { toast } from "react-toastify";
import FrontLoader from "../component/layout/FrontLoader";
import { Rating } from '@smastrom/react-rating'
import '@smastrom/react-rating/style.css'



const SurveyModal = (props:any) => {
  const [selectedStars, setSelectedStars] = useState(0);
  const [experience , setExperience] = useState(0)
  const [corresponds , setCorresponds] = useState(0)
  const [future , setFuture] = useState('')
  const [content , setContent] = useState('')
  const SurveyAdd = useMakeRequest()

  const handelSubmit = (e:any)=>{
    e.preventDefault()
    if(content?.length <= 0 || selectedStars == 0 || experience == 0 || corresponds == 0 ){
      return toast.error(LanguageConstants?.overall_experience)
    }
    if(!future){
      return toast.error(LanguageConstants?.overall_experience)
    }

    const payload = {
     order_id:props?.data?.uuid,
     content:content,
     future_purchases:future,
     payment_experience:experience,
     shopping_experience:selectedStars,
     product_received_corresponds:corresponds
    }
    SurveyAdd.makeRequest({payload,url: ApiConstants?.QuotesAddSurvery,toastStatus: true});
  }

  useEffect(()=>{
   if(SurveyAdd?.status){
    props?.setSurveyShow(false)
    props?.setApiRefresh(true)
   }
  },[SurveyAdd.status])
  return (
    <>
      <style>{`
.survey-form {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.question-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.question-label {
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 500;
  line-height: 1.5;
}

/* Star Rating Styles */
.star-rating {
  display: flex;
  gap: 8px;
}

.star {
  font-size: 10px;
  color: #e0e0e0;
  cursor: pointer;
  transition: color 0.2s;
}
.star-rating img{
  width: 20px;
}

.star.filled {
  color: #fbbf24;
}

.star:hover {
  color: #fbbf24;
}

/* Button Group Styles */
.button-group {
  display: flex;
  gap: 12px;
}

.choice-btn {
  min-width: 70px;
  padding: 4px 10px;
  border: 1px solid #7c3aed;
  background-color: #ffffff;
  color: #7c3aed;
  border-radius: 24px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.choice-btn:hover {
  background-color: #7c3aed;
  color: #ffffff;
}

.choice-btn.active {
  background-color: #7c3aed;
  color: #ffffff;
}


/* Text Area Styles */
.review-input {
  width: 100%;
  padding: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;
}

.review-input::placeholder {
  color: #9ca3af;
}

.review-input:focus {
  outline: none;
  border-color: #7c3aed;
}

/* Submit Button Styles */
.submit-btn {
  width: 100%;
  padding: 16px;
  background-color: #7c3aed;
  color: #ffffff;
  border: none;
  border-radius: 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 8px;
}

.submit-btn:hover {
  background-color: #6d28d9;
}

.submit-btn:active {
  transform: scale(0.98);
}

/* Responsive Design */
@media (max-width: 480px) {

  .star {
    font-size: 28px;
  }
}`}</style>

{SurveyAdd?.loading ? <FrontLoader/> : null}
      <div
        className="modal fade com-modal show"
        id="surveymessage"
        aria-labelledby="editMessageProductModalLabel"
        aria-hidden="false"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editMessageProductModalLabel">
                {LanguageConstants?.SURVEY}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={()=>props?.setSurveyShow(false)}
              >
                <i className="icon-close-square" />
              </button>
            </div>
            <div className="modal-body">
              <div className="survey-container">
                <form className="survey-form" onSubmit={handelSubmit}>
                  {/* Question 1 */}
                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONONE}
                    </label>
                    <div className="star-rating">
                      {Array.from({ length: 6 }, (_, i) => (
                        <img
                          key={i}
                          src={i < selectedStars ? fillStart : halfStart}
                          alt={`Star ${i + 1}`}
                          onClick={() => setSelectedStars(i + 1)}
                          onMouseEnter={(e: any) => {
                            const stars: any = Array.from(
                              e.target.parentElement.querySelectorAll("img")
                            );
                            stars.forEach((star: any, index: any) => {
                              star.src = index <= i ? fillStart : halfStart;
                            });
                          }}
                          onMouseLeave={(e: any) => {
                            const stars: any = Array.from(
                              e.target.parentElement.querySelectorAll("img")
                            );
                            stars.forEach((star: any, index: any) => {
                              star.src =
                                index < selectedStars ? fillStart : halfStart;
                            });
                          }}
                        />
                      ))}
                    </div>
                  </div>
                  {/* Question 2 */}
                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONTWO}

                    </label>
                    <div className="star-rating">
                      {Array.from({ length: 6 }, (_, i) => (
                        <img
                          key={i}
                          src={i < experience ? fillStart : halfStart}
                          alt={`Star ${i + 1}`}
                          onClick={() => setExperience(i + 1)}
                          onMouseEnter={(e: any) => {
                            const stars: any = Array.from(
                              e.target.parentElement.querySelectorAll("img")
                            );
                            stars.forEach((star: any, index: any) => {
                              star.src = index <= i ? fillStart : halfStart;
                            });
                          }}
                          onMouseLeave={(e: any) => {
                            const stars: any = Array.from(
                              e.target.parentElement.querySelectorAll("img")
                            );
                            stars.forEach((star: any, index: any) => {
                              star.src =
                                index < experience ? fillStart : halfStart;
                            });
                          }}
                        />
                      ))}
                    </div>
                  </div>
                  {/* Question 3 */}
                  <div className="question-group">
                    <label className="question-label">
                     {LanguageConstants?.QUESTIONTHREE}
                    </label>
                    <div className="star-rating">
                      {Array.from({ length: 6 }, (_, i) => (
                        <img
                          key={i}
                          src={i < corresponds ? fillStart : halfStart}
                          alt={`Star ${i + 1}`}
                          onClick={() => setCorresponds(i + 1)}
                          onMouseEnter={(e: any) => {
                            const stars: any = Array.from(
                              e.target.parentElement.querySelectorAll("img")
                            );
                            stars.forEach((star: any, index: any) => {
                              star.src = index <= i ? fillStart : halfStart;
                            });
                          }}
                          onMouseLeave={(e: any) => {
                            const stars: any = Array.from(
                              e.target.parentElement.querySelectorAll("img")
                            );
                            stars.forEach((star: any, index: any) => {
                              star.src =
                                index < corresponds ? fillStart : halfStart;
                            });
                          }}
                        />
                      ))}
                    </div>
                  </div>
                  {/* Question 4 */}
                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONFOUR}
                    </label>
                    <div className="button-group">
                      <button type="button" onClick={()=> setFuture('0')} className={future == "0" ? "choice-btn active" : 'choice-btn'}>
                        No
                      </button>
                      <button type="button" onClick={()=> setFuture('1')} className={future == "1" ? "choice-btn active" : 'choice-btn'}>
                        Yes
                      </button>
                    </div>
                  </div>
                  {/* Question 5 */}
                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONFIVE}
                    </label>
                    <textarea
                      className="review-input"
                      placeholder="Share your thoughts"
                      rows={4}
                      defaultValue={""}
                      onChange={(e)=> setContent(e?.target?.value)}
                    />
                  </div>
                  {/* Submit Button */}
                  <button type="submit" className="submit-btn" onClick={handelSubmit}>
                    Submit Survey
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SurveyModal;
